import { css } from "@emotion/react";

// custom
import NitoelHelpIcon from "components/atoms/NitoelHelpIcon";

// mui
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

export type HelpInfoType = {
  resource: string;
  key: string;
};

type InputLabelProps = {
  label: string;
  chipLabels?: string[];
  required?: boolean;
  helpInfo?: HelpInfoType;
  helpMessage?: string;
};

const InputLabel: React.FC<InputLabelProps> = (props) => {
  const { label, chipLabels, required, helpInfo, helpMessage } = props;
  const theme = useTheme();

  const style = {
    root: css`
      font-weight: bold;
      font-size: 12px;
    `,
    label: css`
      font-weight: bold;
      font-size: 12px;
      ${required &&
      `:after {
        color: ${theme.palette.error.main};
        content: " *";
      }`}
    `,
  };

  return (
    <Stack direction="row" alignItems="center" mb={0.5}>
      <Stack direction="row" css={style.root}>
        <Typography variant="body2" css={style.label}>
          {label}
        </Typography>
        {helpMessage && <NitoelHelpIcon message={helpMessage} />}
        {!helpMessage && helpInfo && <NitoelHelpIcon resource={helpInfo.resource} helpKey={helpInfo.key} />}
      </Stack>
      {chipLabels &&
        chipLabels.map((chipLabel, idx) => {
          return (
            <Chip
              key={idx}
              size="small"
              label={chipLabel}
              variant="outlined"
              sx={{ marginLeft: "5px", fontWeight: "inherit", fontSize: "9px" }}
            />
          );
        })}
    </Stack>
  );
};

export default InputLabel;
